export default __webpack_public_path__ + "static/media/icn-calculator-off.c933ccbe.svg";